import gsap from 'gsap'
import LocomotiveScroll from 'locomotive-scroll'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { setupMenuNavigation, setupMenuAction } from './menu'
import { setupForAnimating } from './animations/setup'
import { setupPostActions } from './posts'
import { breakpointDown, breakpointUp } from './utils/breakpoints'
import { setupRankingActions } from './rankings'

gsap.registerPlugin(ScrollTrigger)

let scrollerElement = '.smooth-scroll'
var locoScroll = null

if ($(scrollerElement).length) {

  $(window).on('load', function (e) {

    if (breakpointUp('lg')) {

      locoScroll = new LocomotiveScroll({
        el: document.querySelector(scrollerElement),
        smooth: true,
        tablet: { smooth: true },
        smartphone: { smooth: true },
        lerp: 0.075,
      })

      // each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
      locoScroll.on('scroll', ScrollTrigger.update)

      // tell ScrollTrigger to use these proxy methods for the scrollerElement element since Locomotive Scroll is hijacking things
      ScrollTrigger.scrollerProxy('#scroll', {
        scrollTop (value) {
          return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y
        }, // we don't have to define a scrollLeft because we're only scrolling vertically.
        getBoundingClientRect () {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          }
        },
        // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
        pinType: document.querySelector('#scroll').style.transform ? 'transform' : 'fixed',
      })

      // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
      ScrollTrigger.addEventListener('refresh', () => locoScroll.update())

      // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
      ScrollTrigger.refresh()
    }

    setupMenuNavigation(locoScroll, scrollerElement)
    setupForAnimating(scrollerElement)
    setupMenuAction(locoScroll)

    // Pagination
    setupPostActions(locoScroll)
    setupRankingActions(locoScroll)
  })


}

function updateLocoScroll()
{
  if(locoScroll && breakpointUp('xl')) {
    locoScroll.update()
  }
}

let checkLimit = 250
let recheckTime = 10

function waitForLocoScrollUpdate(loadingContainer)
{
  let can = parseInt($(loadingContainer).attr('data-post-loading'))
  checkLimit -= 1

  if(can === 0 || checkLimit <= 0) {
    updateLocoScroll()
    checkLimit = 250
    if(recheckTime > 0) {
      setTimeout(function (){
        waitForLocoScrollUpdate(loadingContainer)
        recheckTime -= 1
      }, 250)
    } else {
      recheckTime = 10
    }
  } else {
    setTimeout(function (){
      waitForLocoScrollUpdate(loadingContainer)
    }, 100)
  }

}

export { updateLocoScroll, waitForLocoScrollUpdate }
